export default __webpack_public_path__ + "static/media/VersionOneBadgeIcon.c864b18a.svg";